import { useState, useCallback, useEffect } from 'react';
import { handleWarning } from '../error-reporting';
import type { AppValues } from '@tectonics/app-values';

type RegisterSubmitTry = (failed: boolean) => void;

export function useSubmitTriesCount(appValues: AppValues, limit = 10): RegisterSubmitTry {
  const [count, setCount] = useState(0);

  const registerSubmitTry = useCallback((failed: boolean) => {
    if (failed) {
      setCount((last) => last + 1);
    } else {
      setCount(0);
    }
  }, [setCount]);

  useEffect(() => {
    if (count >= limit) {
      setCount(0);

      if (appValues['abwAlertsBlock']) {
        return;
      }

      handleWarning(new Error(`ABW: There has been more than ${limit} unsuccessful Submit tries.`));
    }
  }, [count, limit]);

  return registerSubmitTry;
}
